import { render, staticRenderFns } from "./productClassInfo.vue?vue&type=template&id=4fb75aed&scoped=true&"
import script from "./productClassInfo.vue?vue&type=script&lang=js&"
export * from "./productClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./productClassInfo.vue?vue&type=style&index=0&id=4fb75aed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb75aed",
  null
  
)

export default component.exports